<template>
    <div class="page questions-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <questions v-if="current_directory || categories.data" :path="path" :categories="categories" :questions="questions" :current_directory="current_directory" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Questions from './Questions'

export default {
    name: "",
    components: {
        Questions
    },
    data(){
        return {
            loading: false,
            categories: {
                data: null
            },
            questions: {
                data: null,
                links: null,
                meta: null,
            },
            current_directory: null,
        }
    },
    computed: {
        ...GlobalComputed,
        path(){
            const query = this.$route.query.path;
            return '/exams/questions' + (query ? query.replaceAll('_', '/') : '');
        },
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                window.axios.get(this.path).then(response=>{
                    let categories = response.data.categories;
                    if (response.data.other_dir){
                        if (categories && categories.data){
                            categories.data.push(response.data.other_dir)
                        }else{
                            categories.data = [response.data.other_dir];
                        }
                    }
                    this.categories = categories;
                    this.questions = response.data.questions;
                    this.current_directory = response.data.current_directory;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        // this.$router.push('/not-found');
                        this.showMsg('لم يتم العثور على نتيجة');
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
    },
    watch: {
        path(path){
            this.loadData();
        },
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    created(){
        
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
.stats{
    margin: -8px;
    .col-lg-3, .col-lg-4{
        padding: 8px!important;
    }
}
</style>
